import { MODAL_ACTIONS, MODAL_ACTION_TYPES } from "../actions/modal"
import { ModalType } from "../../Modal/ModalTypes"
import { LAYOUT_ACTIONS, LayoutUpdateAvailabilityAction } from "../actions/channelLayout"

export type ModalState = {
  isOpen: boolean
  data?: ModalPayload
}

export type ModalPayload = ModalChartState | ModalFormState | ModalUrlState | ModalVimeoState | ModalShareCellState

type ModalFormState = {
  type: ModalType.Form
  formName: string
}

type ModalChartState = {
  type: ModalType.Chart
  cellId: number
}

type ModalUrlState = {
  type: ModalType.Url
  url: string,
  title: string
  promptButton?: {
    title: string,
    action: Function
  },
  disableClose?: boolean
}

type ModalVimeoState = {
  type: ModalType.Vimeo
  vimeoId: number,
  title: string
}

type ModalShareCellState = {
  type: ModalType.ShareCell
  cellId: number,
  cellTitle: string,
  cellUrl: string
}

const initialState: ModalState = {
  isOpen: false,
}

export default (state = initialState, action: MODAL_ACTION_TYPES | LayoutUpdateAvailabilityAction): ModalState => {
  switch (action.type) {
    case MODAL_ACTIONS.MODAL_OPENED:
      return {
        ...state,
        isOpen: true,
        data: action.payload
      }
    case MODAL_ACTIONS.MODAL_CLOSED:
      return {
        isOpen: false,
      }
    case LAYOUT_ACTIONS.LAYOUT_UPDATE_BECAME_AVAILABLE:
      // Close the modal when a layout update prompt opens
      return {
        isOpen: false
      }
    default:
      return state
  }
}